import type { FaireProductEntity } from "../../entity_types/product";

export const p_6jqbe5sgjp: FaireProductEntity = {
  token: "p_6jqbe5sgjp",
  type: "product",
  name: "Cloud II™ Classic Tank - Oxford Stripe",
  brandToken: "b_qa8gaqqvwt",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/a88950855a989f014adec697ff176abaf272122dc0d2fae02c4fd3b5fb9c4839.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/45bdb3e80a1575e21a0361e835c1bf714f3dc229fe5dbc4ad72e1f845d8f3d51.jpeg",
    "https://cdn.faire.com/fastly/aebfb128b743433a33f76c0de98ec969c0d515b09e4ed538ff43bf13fab08da7.jpeg",
    "https://cdn.faire.com/fastly/cd7f71dbda548c3100c5274c9b4d945a14aac7fd1efff67387c33c6ef9aa4e5e.jpeg",
    "https://cdn.faire.com/fastly/7d15fa0ec2993de95effcc8b23f1e3fae7dc4cc0efbddd5c54c8a9f1becfb8e4.jpeg",
    "https://cdn.faire.com/fastly/ed5cd9c55a27766f93d8f35cc619f9c62443df583e9759817e7167e7adde2105.jpeg",
  ],
  priceDollars: 52.5,
  description:
    "At Vitality, we’re always looking for ways to elevate your wardrobe staples. Case in point: the Cloud II Classic Tank, a deceptively simple workout tank with a scoop hem, removable bust pads, and no-dig underbust band. But look a little closer and you’ll see that—unlike other activewear tanks on the market—the Classic Tank’s adjustable shoulder straps connect at the back rather than in the front, giving a sleeker, cleaner, dressier finish. Because every detail matters.\n",
  tags: [],
  msrpDollars: 105,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:27:32.358Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
